module.exports = __webpack_public_path__ + "img/矢量智能对象(4).ccd30d07.png";